import React, { FC, useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { ISfWallet } from '@sparling/financial-common'
// import { GreenButton } from '../../../../components/Buttons/GreenButton'
import { IDataItem, TableComponent } from '../../../../components/Table'
// import { icons } from '../../../../constants/icons'
import { columns } from './WalletsList'
import { sfWalletsIsLoading, getSfWalletsData } from '../../../../store/selectors'
import { getSfWalletsRequest } from '../../../../store/actions'
import { WalletsModal } from './WalletsModal'
import { WalletsFilters } from './WalletsFilters'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    height: '100%',
  },
  titleWrap: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minWidth: 400,
  },
  table: {
    paddingTop: theme.spacing(2),
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
}))

export const Wallets: FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const walletsIsLoading = useSelector(sfWalletsIsLoading)
  const { items, meta } = useSelector(getSfWalletsData)
  const [isOpenWalletModal, setOpenWalletModal] = useState<boolean>(false)
  const [selectedWalletId, setSelectedWalletId] = useState<number | null>(null)

  const loadWalletsData = useCallback(
    (page = 1) => {
      dispatch(
        getSfWalletsRequest({
          page,
        }),
      )
    },
    [dispatch],
  )

  useEffect(() => {
    loadWalletsData()
  }, [loadWalletsData])

  const getSelectedElementIdHandle = useCallback((id) => {
    setSelectedWalletId(id)
  }, [])

  const openWalletModalHandle = useCallback(() => {
    setOpenWalletModal(true)
    setSelectedWalletId(null)
  }, [])

  const closeWalletModalHandle = useCallback(() => setOpenWalletModal(false), [])

  return (
    <>
      <Grid container className={classes.container}>
        <Grid container className={classes.titleWrap}>
          <Grid item xs={12} sm={10} display="flex">
            <WalletsFilters />
          </Grid>
          {/* <Grid item xs={12} sm={2} display="flex" justifyContent={'flex-end'}> */}
          {/*  <GreenButton width={140} prefix={icons.ADD} ml={8} text={'Add Wallet'} onClick={openWalletModalHandle} /> */}
          {/* </Grid> */}
        </Grid>
        <Grid container className={classes.table}>
          <TableComponent
            getElementId={getSelectedElementIdHandle}
            columns={columns}
            data={items as IDataItem<ISfWallet>[]}
            params={meta}
            isShowEditIcon={true}
            isShowInfoIcon={false}
            onEdit={openWalletModalHandle}
            loading={walletsIsLoading}
            loadData={loadWalletsData}
          />
        </Grid>
      </Grid>
      {isOpenWalletModal && (
        <WalletsModal
          isOpen={true}
          modalClose={closeWalletModalHandle}
          fields={items.find((item) => item.id === selectedWalletId) as ISfWallet}
        />
      )}
    </>
  )
}
